import { useCallback } from 'react';

import {
  CustomFieldConditionExtraValidator,
  validateCustomFieldConditionExtra,
} from './customFieldConditionExtraValidator';
import { useCustomFieldPickerNodes } from './customFieldConditionPickerNodes';

export const useCustomFieldConditionExtraValidator =
  (): CustomFieldConditionExtraValidator => {
    const { nodesByPath } = useCustomFieldPickerNodes();

    return useCallback(
      (extra) => validateCustomFieldConditionExtra(extra, nodesByPath),
      [nodesByPath]
    );
  };
